/*
 * @FilePath     : /es-template/src/config/interceptors/request/publick.js
 * @Author       : LiYang
 * @Date         : 2021-12-07 11:15:59
 * @LastEditTime: 2023-08-25 00:39:51
 * @LastEditors: liuziwei
 * @Description  : 加密处理统一流程
 */
import { getPublick } from '@/common/publicParams'
import { urlsWithoutLoading } from '../config'
import mpx from '@mpxjs/core'
function openMask() {
  let mask = document.getElementById('windowMask');
  if (!mask) {
    mask = document.createElement('div');
    mask.setAttribute('id', 'windowMask');
    document.body.appendChild(mask);
  }
  mask.style.top = 0;
  mask.style.left =  0;
  mask.style.bottom = 0;
  mask.style.right = 0;
  mask.style.background = 'transparent';
  mask.style.position = 'absolute';
  mask.style.display = 'block';
  mask.style['z-index']= '999';
}
export default config => {
  const { data = {}, params, method, url, timeout } = config

  var isCommonRequest = urlsWithoutLoading.some(item => url?.indexOf(item) > 0)

  var showLoading
  if (isCommonRequest) {
    showLoading = false
  } else {
    if (data) {
      showLoading = data['show_loading']
    }
    if (params) {
      showLoading = params['show_loading']
    }
  }
  
  if (showLoading !== false) {
    openMask();
    mpx.showLoading()
  }

  delete data.show_loading // 不要把show_loading带入到请求参数中去，会引发接口的异常
  config.timeout = timeout || 30000 // 超时时间为30s
  if (params) {
    config.params = getPublick(params, url)
  }
  if (method === 'POST') {
    config.data = getPublick(data, url)
    config.emulateJSON = true
  }
  return config
}
